import axios from 'axios';
import Pusher from 'pusher-js';

let pusherInstance = null;

export const getPusher = () => {
  if (!pusherInstance) {
    pusherInstance = new Pusher(import.meta.env.VITE_PUSHER_KEY, {
      cluster: import.meta.env.VITE_PUSHER_CLUSTER,
      forceTLS: true,
      // Private channels (`private-restaurant.{id}`) are signed by the API at
      // /broadcasting/auth. Plain axios rather than axiosClient: a refused
      // channel must not trip its 401/403 sign-out — the page simply goes
      // without that channel.
      channelAuthorization: {
        customHandler: ({ socketId, channelName }, callback) => {
          axios
            .post(
              `${import.meta.env.VITE_API_BASE_URL}/broadcasting/auth`,
              { socket_id: socketId, channel_name: channelName },
              {
                headers: {
                  'B-API-Key': import.meta.env.VITE_API_KEY,
                  Authorization: localStorage.getItem('accessToken') || '',
                  Accept: 'application/json'
                }
              }
            )
            .then((res) => callback(null, res.data))
            .catch((err) => callback(err, null));
        }
      }
    });
  }
  return pusherInstance;
};
